module.exports = __webpack_public_path__ + "static/media/Resistance.c0d8cdf4.jpg";